// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HC4U","type":"styles_type__2Ybgu","choices":"styles_choices__1AHLM"};